export default {
"species":["Alligator","Anteater","Bear cub","Bear","Bird", "Bull","Cat","Chicken", "Cow", "Deer","Dog","Duck","Eagle","Elephant","Frog","Goat","Gorilla","Hamster","Hippo","Horse","Kangaroo","Koala","Lion","Monkey","Mouse","Octopus","Ostrich","Penguin","Pig","Rabbit","Rhinoceros","Sheep","Squirrel","Tiger","Wolf"],
"chartspecs":{
  "margin":{
        top: 36,
        right: 36,
        bottom: 0,
        left: 36,
  },
  "marginAreabars":{
        top: 32,
        right: 32,
        bottom: 0,
        left: 32,
  },
  "acnhColors":{
    themeColor:"#7cc9c3",
    bgYellowColor:"#fff9e5",
    borderYellowColor:"#f7d359",
    borderDarkerYellowColor:"#F5C24C",
    fontColor:"#786951",
    bgOrangeColor: "#f5c24c",
    bgPinkColor:"#febdc3",
  },
  "colorWheelObjRainbow": {
    "magenta":"#DFADF0",
    "red": "#F98079",
    "yellow": "#FFE49D",
    "green":"#C2DB9D",
    "cyan":"#C0F4F0",
    "blue":"#8DC5F8",
  },
  "colorWheelObjBrightness":{
    "Dark":"#017C74",
    "Medium": "#67B0AC",
    "Light":"#CCE5E3",
  },
  "colorWheelObjGoodlooking":{
    "Very Good Looking":"#016F68",
    "Good Looking": "#349690",
    "Average Looking": "#67B0AC",
    "Slightly Strange Looking":"#99CBC7",
    "Very Strange Looking":"#CCE5E3",
  },
  "colorWheelObjBoolean":{
    "special":"#017c74",
    "normal": "#DEF1F0",
  },
  "colorWheelObjPersonality":{
    "Normal": "#8EC3FB",
    "Lazy": "#F8DC93",
    "Sisterly": "#E9796F",
    "Snooty":"#86597C",
    "Cranky":"#BBD9A3",
    "Jock":"#BDE9EC",
    "Peppy":"#FDD0D4",
    "Smug":"#D7B0EC"
  },
  "colorWheelObjHobby":{
     "Music": "#8EC3FB",
     "Fitness": "#F8DC93",
     "Play": "#378D99",
     "Nature":"#BBD9A3",
     "Fashion":"#D7B0EC",
     "Education":"#6665AB",
   },
   "colorWheelObjStar":{
      "Capricorn": "#017C74",
      "Aquarius": "#017C74",
      "Pisces": "#017C74",
      "Aries":"#017C74",
      "Taurus":"#017C74",
      "Gemini": "#017C74",
      "Cancer": "#017C74",
      "Leo": "#017C74",
      "Virgo":"#017C74",
      "Libra":"#017C74",
      "Scorpio":"#017C74",
      "Sagittarius":"#017C74",
    },
    "colorWheelObj8": {
      "red": "#DD6358",
      "orange": "#EE8D5D",
      "yellow": "#F8D552",
      "green":"#ACE547",
      "greenblue":"#7DE1AE",
      "cyan":"#76D2F2",
      "blue":"#68A0F1",
      "purple":"#9B6EF2"
    },
    "colorWheelObj12":{
      "violet":"#b06ef2",
      "magenta":"#dc6ef2",
      "raspberry":"#f26eb0",
      "red": "#DD6358",
      "orange": "#eea65d",
      "yellow": "#f8f852",
      "yellowgreen":"#95dd4d",
      "green":"#66de4e",
      "turquoise":"#7DE1AE",
      "cyan":"#76f2f2",
      "ocean":"#68A0F1",
      "blue":"#4040ed",
    }
}
}
